import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ChatbotLayout from '../chatbot/ChatbotLayout';
import ChatInterface from '../chatbot/ChatInterface';
import AdminInterface from '../chatbot/AdminInterface';

export default function ChatbotRoute() {
  return (
    <ChatbotLayout>
      <Routes>
        <Route index element={<ChatInterface />} />
        <Route path="admin" element={<AdminInterface />} />
        <Route path="*" element={<Navigate to="" replace />} />
      </Routes>
    </ChatbotLayout>
  );
}